import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=e76821d6"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=e76821d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextTraderHeadMobile: require('/root/workspace/web-company_Yo6Q/components/textTrader/_headMobile.vue').default,DealerTisk: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerTisk.vue').default,DealerModule: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerModule.vue').default})
